var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"leftSide"}},[_c('div',{staticClass:"logo"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.iconSrc}}),_c('hr',{staticClass:"line"})]),_c('p',[_vm._v("Communicate in Harmony")])])}
var staticRenderFns = []

export { render, staticRenderFns }